jQuery(document).ready(function() {
    function setSameHeight(selector) {
    var maxHeight = 0;
    // Reset lại chiều cao để tính toán lại cho đúng khi resize
    $(selector).css('height', 'auto'); 

    $(selector).each(function(){
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    $(selector).css('height', maxHeight + 'px');
    }

    $(document).ready(function() {
    // Gọi hàm khi trang tải xong
    setSameHeight('.prd_info_grid_item');

    // Gọi lại hàm khi thay đổi kích thước cửa sổ
    $(window).on('resize', function() {
        setSameHeight('.prd_info_grid_item');
    });
    });


    $(".control-button--sound").click( function (){
        if( $(this).next().prop('muted') ) {
            $(this).next().prop('muted', false);
        } else {
            $(this).next().prop('muted', true);
        }

        if ($(this).hasClass('sound') ) {
            $(this).removeClass('sound');
        } else {
            $(this).addClass('sound');    
        }
        
    });

    $('#cs-lnk').change(function(){
        if($(this).is(":checked")) {
            $('.changeme').addClass('cs-lnk');
        } else {
            $('.changeme').removeClass('cs-lnk');
        }
    });
    $('input#cs-lnk').prop('checked',false);



});

